class Product {
  constructor(data) {
    const isDefaultData = typeof data === 'undefined';

    this.id = isDefaultData ? '' : data.id;
    this.asin = isDefaultData ? '' : data.asin;
    this.image = isDefaultData ? '' : data.image;
    this.title = isDefaultData ? '' : data.title;
    this.condition = isDefaultData ? '' : data.condition;
    this.quantity = isDefaultData ? '' : data.quantity;
    this.bundle_type = isDefaultData ? '' : data.bundle_type;
    this.in_set = isDefaultData ? '' : data.in_set;
    this.received_date = isDefaultData ? '' : data.received_date;
    this.client_comment = isDefaultData ? '' : data.client_comment;
    this.worker_comment = isDefaultData ? '' : data.worker_comment;
    this.dimensions = isDefaultData ? {} : data.dimensions;
    this.ids = isDefaultData ? '' : data.ids;
    this.product_id = isDefaultData ? null : data.product_id;
    this.fnsku = isDefaultData ? null : data.fnsku;
    this.fnsku_title = data.fnsku_title || data.title || '';
    this.is_non_amazon = data.is_non_amazon || false;
  }

  getProductsSize() {
    if (this.dimensions === null || this.dimensions.volume === null) return 'NaN';

    const fullSize = this.dimensions.volume * this.quantity;
    return `${fullSize.toFixed(2)}&nbsp;(${this.dimensions.volume})&nbsp;ft<sup>3</sup>`;
  }

  getAmazonUrl() {
    return `https://www.amazon.com/dp/${this.asin}`;
  }
}

export default Product;
